module.exports = __webpack_public_path__ + "inscricao/static/media/img-card-green.bcae51b0.png";